// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,

  // baseUrl: 'http://35.222.221.156:4001/',
  // baseUrl: 'https://api-stage.unsub.africa/',
  baseUrl: 'https://api.unsub.africa/',
  // baseUrl: 'http://192.168.1.9:4001/',

  s3IdentityPool: 'ap-south-1:482f5ad2-7d3c-4db0-ac55-1b178db31a7f',
  s3Accesskey: 'AKIAR6SRPD5YQJNVORPY',
  s3SecretKey: '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',
  s3Region: 'AP_SOUTH_1',
  // s3Bucket: 'unsub-stage',
  s3Bucket: 'unsub-prod',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
